import { LayoutGrid, List } from 'lucide-react';
import { Icon } from '../ui';
import type { DirectoryViewMode } from './types';

// Segmented Cards | List selector. Controlled: the parent owns the value and
// persists it. Echoes the sidebar sub-tab active-underline idiom via CSS.
export function ViewToggle({
  value,
  onChange,
}: {
  value: DirectoryViewMode;
  onChange: (mode: DirectoryViewMode) => void;
}): JSX.Element {
  return (
    <div className="view-toggle" role="group" aria-label="View mode">
      <button
        type="button"
        className={`view-toggle-btn ${value === 'cards' ? 'active' : ''}`}
        aria-pressed={value === 'cards'}
        onClick={() => onChange('cards')}
      >
        <Icon icon={LayoutGrid} size={15} />
        <span>Cards</span>
      </button>
      <button
        type="button"
        className={`view-toggle-btn ${value === 'list' ? 'active' : ''}`}
        aria-pressed={value === 'list'}
        onClick={() => onChange('list')}
      >
        <Icon icon={List} size={15} />
        <span>List</span>
      </button>
    </div>
  );
}
